import * as types from "../../../types/static-catalogs/time-zones/index";

export const startFetchingTimeZones = (filters = {}) => ({
  type: types.TIME_ZONES_FETCH_STARTED,
  payload: filters,
});
export const completeFetchingTimeZones = (entities, order) => ({
  type: types.TIME_ZONES_FETCH_COMPLETED,
  payload: {
    entities,
    order,
  },
});
export const failFetchingTimeZones = (
  error = { errorMessage: "Error", errorNumber: 404 }
) => ({
  type: types.TIME_ZONES_FETCH_FAILED,
  payload: {
    error, //error:{errorMessage:'Error', errorNumber:400}
  },
});
